// extracted by mini-css-extract-plugin
export default {"addNewTagButton":"NewTagToCategoryInput_addNewTagButton__KzvcO"};